<div class="consent-container">
  <div class="check-icon">
    <mat-icon  svgIcon="k12-circle-check"></mat-icon>
  </div>
  <h5>{{ isEditMode ? 'Update' : 'New' }} Tutor Agreement</h5>
  <div class="consent-form">
    <p>To {{ isEditMode ? 'edit an existing' : 'add the new' }} Tutor, please confirm you understand the following statements.</p>
    <form [formGroup]="consentForm" class="grid">
      <div class="consent-checkbox col-12">
        <span>By checking this box, I certify that the information I have provided is correct</span>
        <mat-checkbox formControlName="informationConsent" class="consent-checkbox"></mat-checkbox>
      </div>

      <div class="consent-checkbox col-12">
        <span>I consent to the release of the credential information, I have provided to National Student Clearinghouse for verification.</span>
        <mat-checkbox formControlName="credentialReleaseConsent" class="consent-checkbox"></mat-checkbox>
      </div>
    </form>
  </div>
  <div class="consent-action-buttons">
    <button 
      class="cancel-button secondary_materials_button small_button"
      data-qa="cancel-button"
      disableRipple="true"
      id="cancel-button"
      mat-stroked-button
      tabindex="0"
      (click)="onCancelConsentForm()">
        Cancel
    </button>
    <button 
      class="primary_materials_button small_button save-button"
      data-qa="save-button" 
      disableRipple="true"
      id="save-button"
      mat-stroked-button
      tabindex="0"
      [disabled]="!consentForm.valid"
      (click)="onSubmitConsentForm()">
        Accept
    </button>
  </div>
</div>
